import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import './SwitchGroup.module.scss'

/**
 * SwitchGroup options , it will show the grouped button
 * Based on https://react-select.com/home.
 */
const propTypes = {
  /**
   * Options containing value and label.
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.node.isRequired,
      label: PropTypes.node.isRequired,
    }),
  ),
  /**
   * Callback for when the option gets clicked
   */
  setValue: PropTypes.func.isRequired,
  /**
   * value for the selected index
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * disabled for the grouped buttons
   */
  disabled: PropTypes.bool,
  /**
   * width for the grouped buttons
   */
  width: PropTypes.number,
  /**
   * title text
   */
  title: PropTypes.string,
  /**
   * subTitle text
   */
  subTitle: PropTypes.string,

  /**
   * Boolean filed which set equal space between the button or not
   */
  isSpaceBetween: PropTypes.bool,
}

function SwitchGroup(props) {
  const {
    options = [],
    value = '',
    setValue,
    width = 300,
    isSpaceBetween = false,
    title = '',
    subTitle = '',
    disabled = false,
  } = props ?? {}

  return (
    <Row>
      <Col className="my-auto">
        <div className="Uic-SwitchGroup-title">{title}</div>
        <div className="Uic-SwitchGroup-subTitle">{subTitle}</div>
      </Col>
      <Col style={{ display: 'contents' }}>
        <div
          className={[`Uic-SwitchGroup-segemntGroup ${isSpaceBetween ? 'Uic-SwitchGroup-spacebetween' : ''}`]}
          style={{ width }}
        >
          {options.map((item) => (
            <button
              type="button"
              key={item.value}
              disabled={disabled}
              className={item.value === value ? 'Uic-SwitchGroup-segmentActive' : ''}
              onClick={() => {
                if (!disabled) {
                  setValue(item.value)
                }
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      </Col>
    </Row>
  )
}

SwitchGroup.propTypes = propTypes

export default SwitchGroup
